import types from '../../constants';

const initialState = {
  loading: false,
  deleting: false,
  updating: false,
  data: [],
  variables: {},
  variablesOpened: false,
};

const BlackListReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.BLACKLIST_FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case types.BLACKLIST_FETCH_END:
      const { blacklist, config } = action.payload;

      return {
        ...state,
        data: blacklist,
        variables: config,
        loading: false,
      };
    case types.BLACKLIST_SHOW_HIDE_VARIABLES:
      return {
        ...state,
        variablesOpened: !state.variablesOpened,
      };
    case types.BLACKLIST_DELETE_START:
      return {
        ...state,
        deleting: true,
      };
    case types.BLACKLIST_DELETE_END:
      return {
        ...state,
        deleting: false,
      };
    case types.BLACKLIST_UPDATE_START:
      return {
        ...state,
        updating: true,
      };
    case types.BLACKLIST_UPDATE_END:
      return {
        ...state,
        updating: false,
      };
    case types.BLACKLIST_CHANGE_VARIABLE:
      const newState = { ...state };
      const { variable, value } = action.payload;

      newState.variables[variable] = Number(value);

      return newState;
    default:
      return state;
  }
};

export default BlackListReducers;
